import { cn } from '@/utils/style';
import React from 'react';

interface NaverAdSkeletonProps {
  className?: string;
  style?: React.CSSProperties;
}

const NaverAdSkeleton: React.FC<NaverAdSkeletonProps> = ({ className = '', style = {} }) => {
  return (
    <div className={cn('p-[20px]', className)} style={style}>
      <div className='flex min-h-[140px] flex-col gap-[12px] overflow-hidden rounded-lg border border-gray-200 border-solid bg-white p-[12px]'>
        {/* Header skeleton */}
        <div className='flex items-center justify-between border-gray-100 border-b pb-[8px]'>
          <div className='flex items-center gap-[4px]'>
            <div className='h-[20px] w-[60px] animate-pulse rounded-[4px] bg-gray-40' />
            <div className='h-[16px] w-[24px] animate-pulse rounded-[4px] bg-gray-40' />
          </div>
          <div className='h-[14px] w-[48px] animate-pulse rounded-[4px] bg-gray-40' />
        </div>

        {/* Content skeleton */}
        <div className='flex flex-col gap-[12px]'>
          <div className='flex items-start gap-[12px]'>
            <div className='min-w-0 flex-1'>
              {/* Title skeleton */}
              <div className='mb-[4px] flex items-center gap-[6px]'>
                <div className='h-[16px] w-[16px] animate-pulse rounded-[4px] bg-gray-40' />
                <div className='h-[20px] w-[200px] animate-pulse rounded-[4px] bg-gray-40' />
                <div className='h-[16px] w-[16px] animate-pulse rounded-[4px] bg-gray-40' />
              </div>

              {/* URL skeleton */}
              <div className='mb-[8px]'>
                <div className='h-[16px] w-[150px] animate-pulse rounded-[4px] bg-gray-40' />
              </div>

              {/* Description skeleton */}
              <div className='flex flex-col gap-[4px]'>
                <div className='h-[16px] w-full animate-pulse rounded-[4px] bg-gray-40' />
                <div className='h-[16px] w-[80%] animate-pulse rounded-[4px] bg-gray-40' />
              </div>

              {/* Tags skeleton */}
              <div className='my-[8px] flex flex-wrap gap-[4px]'>
                <div className='h-[24px] w-[60px] animate-pulse rounded-[4px] bg-gray-40' />
              </div>
            </div>

            {/* Image skeleton */}
            <div className='flex-shrink-0'>
              <div className='h-[60px] w-[60px] animate-pulse rounded-[8px] bg-gray-40' />
            </div>
          </div>
          <div className='flex items-start gap-[12px]'>
            <div className='min-w-0 flex-1'>
              {/* Title skeleton */}
              <div className='mb-[4px] flex items-center gap-[6px]'>
                <div className='h-[16px] w-[16px] animate-pulse rounded-[4px] bg-gray-40' />
                <div className='h-[20px] w-[200px] animate-pulse rounded-[4px] bg-gray-40' />
                <div className='h-[16px] w-[16px] animate-pulse rounded-[4px] bg-gray-40' />
              </div>

              {/* URL skeleton */}
              <div className='mb-[8px]'>
                <div className='h-[16px] w-[150px] animate-pulse rounded-[4px] bg-gray-40' />
              </div>

              {/* Description skeleton */}
              <div className='flex flex-col gap-[4px]'>
                <div className='h-[16px] w-full animate-pulse rounded-[4px] bg-gray-40' />
                <div className='h-[16px] w-[80%] animate-pulse rounded-[4px] bg-gray-40' />
              </div>

              {/* Tags skeleton */}
              <div className='my-[8px] flex flex-wrap gap-[4px]'>
                <div className='h-[24px] w-[60px] animate-pulse rounded-[4px] bg-gray-40' />
              </div>
            </div>

            {/* Image skeleton */}
            <div className='flex-shrink-0'>
              <div className='h-[60px] w-[60px] animate-pulse rounded-[8px] bg-gray-40' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NaverAdSkeleton;
